import type { ShipDef } from '../../sim/defs';
import { Stat } from '../../sim/stats';

/** V01 — AEGIS. « Lent et lourdement blindé, bombe rechargeable au frôlement »
 *  (nœud `vaisseau-aegis`, 3 200 crédits, le plus cher de l'arbre).
 *
 *  ── L'échange, et son prix réel ───────────────────────────────────────────
 *  −25 % de vitesse de déplacement contre une vie et du frôlement. Sur le
 *  papier c'est équilibré ; en jeu, c'est cher. La vitesse est la statistique
 *  d'ESQUIVE — celle qui décide si un rideau est franchissable — et la méta
 *  entière ne peut en offrir que +8 %. AEGIS en rend trois fois plus qu'un
 *  arbre complet n'en donne. C'est délibéré : le nœud le plus cher du jeu doit
 *  changer la façon de jouer, pas ajouter un pourcentage.
 *
 *  Ce que la vie supplémentaire achète en échange n'est pas de la puissance
 *  mais des TENTATIVES : +1 vie sur 3, c'est un tiers de run en plus pour
 *  apprendre un pattern qu'on ne franchit pas encore. Le joueur lent qui meurt
 *  une fois de plus au monde 2 y arrive quand même.
 *
 *  ── Pourquoi le frôlement, et pas les dégâts ──────────────────────────────
 *  Une coque lente est collée aux projectiles par construction : elle ne sort
 *  pas des rideaux, elle les traverse. Élargir son rayon de frôlement récompense
 *  ce qu'elle subit déjà au lieu de le compenser — et c'est ce qui rattache
 *  l'économie d'AEGIS à sa promesse de bombe.
 *
 *  ⚠️ `grazeBombCharge` : 120 frôlements par bombe regagnée. Le jalon
 *  « frolement-200 » demande 200 frôlements dans une run, ce qui situe l'ordre
 *  de grandeur — une à deux bombes par run pour un joueur qui frôle, aucune
 *  pour celui qui fuit. C'est une valeur de DÉPART, à régler par le système qui
 *  la consommera ; elle est ici pour que la promesse du nœud soit greppable et
 *  non pas oubliée dans un texte d'interface.
 *
 *  ⚠️ `maxBombs +1` ne fait RIEN aujourd'hui : `World.reset()` pose
 *  `p.bombs = FEEL.bombsAtStart` et aucun système ne lit `stats.maxBombs` (les
 *  cartes « +1 bombe » du pool sont inertes pour la même raison). Le
 *  modificateur reste ici parce qu'il est la bonne façon de dire la chose ; le
 *  jour où le stock de bombes se lira dans les statistiques, il s'appliquera
 *  sans qu'on ait à retoucher ce fichier. */
const aegis: ShipDef = {
  id: 'aegis',
  name: 'AEGIS',
  modifiers: [
    { stat: Stat.MoveSpeed, op: 'mul', value: -0.25 },
    // Additif entier, jamais multiplicatif : une vie ne se coupe pas en
    // morceaux et `computeStats` n'arrondit que `bulletCount`. Même raison que
    // `metaModifiers`.
    { stat: Stat.MaxLives, op: 'add', value: 1 },
    { stat: Stat.MaxBombs, op: 'add', value: 1 },
    { stat: Stat.GrazeRadius, op: 'mul', value: 0.3 },
  ],
  secondaryCooldownMul: 1,
  grazeBombCharge: 120,
  text: '−25 % de vitesse, +1 vie, +1 bombe, +30 % de rayon de frôlement.',
};

export default aegis;
